<template>
  <section class="rows">
    <div class="container">
      <div class="content reporting-row">
        <div class=" container form-group col-lg-5">
          <label>Villes</label>
          <select v-on:change="changedSelect()"
                  v-model="selectedVille"
                  class="form-control demande-filters"
                  id="ville"
          >
            <option value="0">Sélectionner une ville</option>
            <option
              v-for="ville in villes.availableVilles"
              v-bind:value="ville"
              v-bind:item="selectedVille"
              v-bind:key="ville.id"
            >
              {{ ville.nom }}
            </option>
          </select>
        </div>
        <div class="col-sm-2 pull-right">
          <label>&nbsp;</label>
          <button
            type="button"
            v-on:click="saveModifications()"
            class="btn btn-block save-btn"
          >
            Sauvegarder
          </button>
        </div>
      </div>
    </div>
    <div class="container" v-if="selectedVille!=='0'">

      <h2>VAD :</h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='VAD'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>

      <h2>Controle du matériel :</h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='Controle du matériel'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>

      <h2>Déclarer :</h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='Déclarer'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>

      <h2>Débordement : </h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='Débordement'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>

      <h2>Evénement : </h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='Evénement'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>

      <h2>Dépôt de sac : </h2>
      <div class="row" v-for="mod in selectedVille.parametrageapks" :key="mod.nom" v-if="mod.module ==='Dépot_de_sac'">
        <div class="col-md-8">
          <span class="title-item">Outil</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import {anomalieList} from '../../../const'
import _ from 'lodash'

export default {
  components: {Treeselect},
  computed: {
    ...mapState([
      'villes',
    ]),
  },
  data: function () {
    return {
      selectedModules: [],
      selectedVille: '0',
      modules: [],
    }
  },
  mounted: function () {
    this.anomalieList = anomalieList()
    this.$store.dispatch('fetchAllVilles')
    console.log("villes => " , this.$store.state.villes.availableVilles)
  },
  methods: {
    saveModifications: function () {
      this.$store.dispatch('updateModulesOfVille', {selectedVille: this.selectedVille, module: 'APK'})
    },
    changedSelect: function () {

      if (this.selectedVille.parametrageapks) {
        const index = this.$store.state.villes.data.map(item => item.id).indexOf(this.selectedVille.id)
        console.log('index => ', index)
        console.log('Original => ', this.$store.state.villes.data[index].parametrageapks)
        console.log('Displayed => ', this.$store.state.villes.availableVilles[index].parametrageapks)
        this.$store.state.villes.availableVilles[index].parametrageapks = _.cloneDeep(this.$store.state.villes.data[index].parametrageapks)
      }
    }
  },
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.row.reporting-row {
  align-items: start;
}

.content {
  min-height: 120px
}

button.save-btn {
  background-color: $suez-blue;
  background-repeat: no-repeat;
  background-position: 15px center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none;
  padding: 7px 15px 8px 20px;
}

.big-checkbox {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// AdministrationAndroid.vue?aa0da2d8